import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Pulse = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M11 26C7.75002 26 6.80002 22.837 6.03702 20.288C5.23702 17.625 4.63702 16 2.99902 16C2.44902 16 1.99902 15.55 1.99902 15C1.99902 14.45 2.44902 14 2.99902 14C6.24902 14 7.19902 17.163 7.96202 19.712C8.76202 22.375 9.36202 24 10.999 24C12.737 24 14.011 19.413 15.036 15.738C16.424 10.726 17.736 6 20.999 6C24.249 6 25.199 9.162 25.961 11.713C26.761 14.375 27.361 16 28.999 16C29.549 16 29.999 16.45 29.999 17C29.999 17.55 29.549 18 28.999 18C25.749 18 24.799 14.838 24.037 12.287C23.237 9.625 22.637 8 20.999 8C19.261 8 17.987 12.588 16.961 16.262C15.574 21.274 14.261 26 10.998 26H11Z" />
	</svg>
);

export default Pulse;
